<template>
  <li class="cursor-pointer !border border-grey-300 bg-white" :class="{ '!border-amaranth-300': job.isHot }">
    <NuxtLink :to="jobsHrPaths.job({ locale, slug: job.id })" class="block !text-inherit">
      <div id="job-item" class="flex items-center p-2 pr-3">
        <div class="flex h-16 w-16 items-center tablet:h-24 tablet:w-24">
          <div class="min-w-[4rem] border-r border-r-[#eef1f3] p-2 tablet:min-w-[6rem]">
            <img v-if="job.companyLogoThumb" :src="job.companyLogoThumb" />

            <img v-else src="~/assets/images/company-logo-placeholder.png" />
          </div>
        </div>

        <div class="flex flex-1 flex-col justify-center overflow-hidden pl-6">
          <div class="mb-1 flex items-center">
            <div
              v-if="job.isHot"
              class="mr-2 inline-block shrink-0 rounded-xs bg-red-500 px-2 py-1 text-overline-s-bold font-bold text-white"
            >
              {{ $t('job_details.hot') }}
            </div>

            <div class="truncate text-overline text-[#999]">
              {{ jobLocationFull }},
              {{ $dayjs(job.publishedAt).locale(locale).fromNow() }}
            </div>
          </div>

          <h4 class="mb-1 truncate text-headline-s">
            {{ job.title }}
          </h4>

          <div class="hidden tablet:block">
            {{ job.companyName }}
          </div>
        </div>

        <div class="h-6 w-6 shrink-0">
          <img class="h-6 w-6" src="@/assets/images/chevron-right_24px.svg" />
        </div>
      </div>
    </NuxtLink>
  </li>
</template>

<script setup lang="ts">
import { jobsHrPaths } from '@ramp106/omrjs-routing'
import { toRef } from 'vue'

import { useJobDetails } from '@/helpers/jobHelpers'

import { NuxtLink } from '#components'
import { useI18n } from '#imports'
import type { SearchJobType } from '~/gql/jobs/queries/searchJobs/types'

const { locale } = useI18n()

const props = defineProps<{
  job: SearchJobType
}>()

const { jobLocationFull } = useJobDetails(toRef(() => props.job))
</script>
